var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialYtC(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.57439 3.82837C9.69845 3.95244 9.78778 4.10689 9.83346 4.27629C10 4.89967 10 6.20108 10 6.20108C10 6.20108 10 7.50249 9.83346 8.12587C9.7875 8.29567 9.69767 8.45039 9.57299 8.57448C9.44832 8.69858 9.29319 8.78769 9.12318 8.83286C8.49979 9.00006 5.99835 9.00006 5.99835 9.00006C5.99835 9.00006 3.49757 9.00006 2.87419 8.83286C2.70473 8.7873 2.55021 8.69801 2.42613 8.57393C2.30205 8.44985 2.21276 8.29533 2.1672 8.12587C2 7.50249 2 6.20108 2 6.20108C2 6.20108 2 4.89967 2.17049 4.27629C2.21605 4.10683 2.30534 3.95231 2.42942 3.82823C2.5535 3.70415 2.70802 3.61486 2.87748 3.5693C3.50021 3.4021 6.00165 3.4021 6.00165 3.4021C6.00165 3.4021 8.50243 3.4021 9.12647 3.5693C9.29587 3.61498 9.45032 3.70431 9.57439 3.82837ZM7.27679 6.20108L5.19862 7.40046V5.00171L7.27679 6.20108Z",
    fill: "#FF4433"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialYtC);
export default __webpack_public_path__ + "static/media/social_yt_c.84e69237252aa20fcb61fba7e0d3fd1b.svg";
export { ForwardRef as ReactComponent };